import * as Yup from 'yup';

export const contactSchema = Yup.object({
  fullName: Yup.string()
    .required('Full Name is required'),
  email: Yup.string()
    .email('Invalid email address')
    .required('Email is required'),
  phone: Yup.string()
    .matches(/^[0-9]+$/, 'Phone number must be a digit')
    .min(10, 'Phone number must be at least 10 digits')
    .required('Phone Number is required'),
  subject: Yup.string()
    .required('Subject is required'),
  message: Yup.string()
    .required('Message is required')
    .min(10, 'Message must be at least 10 characters')
    .max(1000, 'Message cannot exceed 1000 characters'),
});